export class licence{
  _id?:string;
  licence_name:string;
  duration : number;
  price:number;
  licence_type : string;
  contents : string;
  description : string;
  paid_status:string;
  selected_courses : Array<any>;
  selected_certificates : Array<any>;
}



// WEBPACK FOOTER //
// ./src/app/models/licence.ts